var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHoverstateiconCosmeticflow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17C0 7.61116 7.61116 0 17 0V0C26.3888 0 34 7.61116 34 17V17C34 26.3888 26.3888 34 17 34V34C7.61116 34 0 26.3888 0 17V17Z",
    fill: "#D8EAF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9989 10.625C17.0924 13.5037 19.6934 16.1047 22.5721 16.1982C19.6934 16.2463 17.0924 18.8473 16.9989 21.7232C16.9054 18.8473 14.3044 16.2463 11.4258 16.1982C14.3044 16.1047 16.9054 13.5037 16.9989 10.625Z",
    stroke: "#00BD7F",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0417 10.625V13.4583M10.625 12.0417H13.4583M21.9583 20.5417V23.375M20.5417 21.9583H23.375",
    stroke: "#00BD7F",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverstateiconCosmeticflow);
export default __webpack_public_path__ + "static/media/hover state icon -cosmetic flow.7b420ea262b3e86b5d073973615abba6.svg";
export { ForwardRef as ReactComponent };